var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 34999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.5 71C55.1061 71 71 55.1061 71 35.5C71 15.8939 55.1061 0 35.5 0C15.8939 0 0 15.8939 0 35.5C0 55.1061 15.8939 71 35.5 71Z",
    fill: "#0DA06E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.5 0C15.8933 0 0 15.8933 0 35.5C0 55.1066 15.8933 71 35.5 71C55.1066 71 71 55.1066 71 35.5C71 15.8933 55.1066 0 35.5 0ZM35.5 67.45C17.8813 67.45 3.55 53.1186 3.55 35.5C3.55 17.8813 17.8813 3.55 35.5 3.55C53.1186 3.55 67.45 17.8813 67.45 35.5C67.45 53.1186 53.1186 67.45 35.5 67.45Z",
    fill: "#01684A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.8793 12L37.8652 12.0285V19.9616H41.8098L35.9793 27.1719L37.8441 29.0555H52.7693V53.1291H20L37.6925 71C53.2805 70.206 66.1964 59.1822 70 44.4447L37.8793 12Z",
    fill: "#01684A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.5384 29.1351L30.9742 24.7935H19.4687V36.0257H13.1035L19.4651 53.1331H19.4687V53.1402H52.4979V29.1387H34.5384V29.1351ZM21.1585 26.4797H30.179L33.7432 30.8214H50.8152V50.6517L45.3766 36.0221H21.1585V26.4797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M41.4606 20.0648H37.4917V12.127H33.6896V20.0648H29.7207L35.5924 27.2571L41.4606 20.0648Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.6ef7090037c2b49040eecf06d9c38192.svg";
export { ForwardRef as ReactComponent };